import downloadJS from 'downloadjs'

export default {
  methods: {
    onDownErrorFile (id) {
      downloadJS(request.items.downErrorFile(id))
    },
    taskBatchPercentage (row) {
      let parts = []
      if (row.total_count <= 0) {
        return parts
      }

      let success = 0
      let error = 0

      if (row.success_count > 0) {
        success = Math.round(row.success_count * 100 / row.total_count)
      }

      if (row.error_count > 0) {
        error = Math.round(row.error_count * 100 / row.total_count)
      }

      if (success + error > 100) {
        error = 100 - success
      }

      if (success > 0) {
        parts.push({
          width: success,
          status: 'default'
        })
      }

      if (error > 0) {
        parts.push({
          width: error,
          status: 'error'
        })
      }

      return parts
    },
    taskBatchStatus (row) {
      switch (row.status) {
        case 1:
        case 2:
          return 'ongoing'
        case 3:
          return 'success'
        case -1:
        case -2:
        case -3:
        case -4:
          return 'error'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/task-batch/task-batch.mixins.js